import React from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  Link,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Logo from "src/components/Logo";
import LinearProgress from "@material-ui/core/LinearProgress";
import WcagButtons from "src/components/layout/WcagButtons";

const useStyles = makeStyles((theme) => ({
  root: {},
  rootLoader: {
    top: 5,
  },
  avatar: {
    width: 60,
    height: 60,
  },
  loader: {
    width: "100%",
    height: 5,
    marginBottom: theme.spacing(0.2),
  },
  logolink: theme.hiContrast
    ? {
        "&:focus": {
          borderBottom: "2px solid #000000",
        },
      }
    : {
        "&:focus": {
          borderBottom: "2px solid #FFFFFF",
        },
      },
}));

const TopBar = ({
  className,
  onMobileNavOpen,
  setLogoutUser,
  isAuthorized,
  loaderOn,
  systemInfo,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <div>
      <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
        <Toolbar>
          <Link
            component={RouterLink}
            variant="h6"
            to={`/`}
            className={classes.logolink}
          >
            <Logo systemInfo={systemInfo} />
          </Link>
          <Box flexGrow={1} />
          <WcagButtons></WcagButtons>

          <Hidden lgUp>
            <IconButton color="inherit" onClick={onMobileNavOpen}>
              <MenuIcon />
            </IconButton>
          </Hidden>
        </Toolbar>
        {loaderOn ? <LinearProgress className={classes.loader} /> : <></>}
      </AppBar>
    </div>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
